var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-row',{staticClass:"ta-header"},[_c('div',{staticClass:"ta-chart-header"},[_vm._v(" "+_vm._s(_vm.$t('charts.staticStresses.title'))+" ")]),_c('div',{attrs:{"id":_vm.id}})])}
var staticRenderFns = []

export { render, staticRenderFns }